import { gql } from '@/__generated__';

export const GET_DEVICE_CONFIGURATION_FILE_HISTORY = gql(`#graphql
  query GetDeviceConfigurationFileHistory($deviceId: ID!) {
    device(input: { id: $deviceId }) {
      id
      hardwareConfiguration {
        id
        configurationFileHistory {
          fileName
          createdAt
        }
      }
    }
  }
`);
